import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const Contact: React.FC = () => {
  const [year, setYear] = useState<number>(new Date().getFullYear());

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
  }, []);

  const navigate = useNavigate();

  return (
    <div
      className="font-small mt-4"
      style={{
        color: "white",
        textAlign: "start",
        marginLeft: 68,
        marginBottom: 224,
      }}
    >
      <div
        onClick={() => navigate("/privacy-policy")}
        style={{
          position: "absolute",
          top: 44,
          left: 0,
          margin: "10px",
          padding: "5px 10px",
          backgroundColor: "#1e5a72",
          color: "white",
          border: "none",
          borderRadius: 8,
          cursor: "pointer",
          boxShadow: "12px 2px 25px rgba(0, 0, 0, 0.4)",
        }}
      >
        ←
      </div>
      <div>
        <h1>Yhteydenotot</h1>
        <p>
          Kiitos mielenkiinnostasi verkkosovellustamme kohtaan! Voit ottaa
          yhteyttä mieltä askarruttavissa asioissa.
        </p>
        <p>
          <strong>Kaupallinen yhteistyö:</strong> Jos sinulla on kiinnostusta
          tehdä yhteistyötä kanssamme, olemme avoimia erilaisille kaupallisille
          projekteille, jotka voivat luoda arvoa molemmille osapuolille.
        </p>
        <p>
          <strong>Sivustoon liittyvät kysymykset:</strong> Mikäli haluat antaa
          palautetta sivustostamme tai tehdä kehitysehdotuksia, otamme
          palautteen kiitollisina vastaan.
        </p>
        <p>
          Mikäli asiasi ei suoraan liity yllä mainittuihin kohtiin, voit silti
          ottaa yhteyttä. Käsittelemme kaikki yhteydenotot huolella ja pyrimme
          vastaamaan mahdollisimman pian.
        </p>

        <p>
          Voit ottaa yhteyttä sähköpostitse{" "}
          <a
            href="mailto:heinaaho.p@gmail.com"
            aria-label="Sähköpostiyhteys"
            style={{ color: "darkturquoise", textDecoration: "none" }}
          >
            tästä linkistä
          </a>
          <br />
          Odotamme yhteydenottoasi!
        </p>
      </div>

      <br />
      <nav
        style={{
          padding: "4px",
          backgroundColor: "#1e5a72",
          color: "lightgray",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          fontSize: 11,
          zIndex: 2,
        }}
      >
        <div
          className="d-flex justify-content-center"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: "800px",
            margin: "0 auto",
            gap: "15px",
          }}
        >
          <Link to="/set-train-number" className="nav-link">
            minunjunani.fi
          </Link>
          <Link to="/privacy-policy" className="nav-link">
            Tietosuojakäytäntö
          </Link>
          <Link to="/cookies" className="nav-link">
            Evästeet
          </Link>
        </div>
        <div className="">&copy; {year} minunjunani.fi</div>
        <a
          href="https://www.digitraffic.fi/kayttoehdot/"
          target="_blank"
          style={{ color: "darkgray" }}
        >
          Liikennetietojen lähde Fintraffic / digitraffic.fi, lisenssi CC 4.0 BY
        </a>
      </nav>
    </div>
  );
};

export default Contact;
